export default __webpack_public_path__ + "static/media/Mawer_Mag1@2x.704ab5a3.jpg";